(function () {
  const API_URL =
    'https://seasonalcampaigns-356018239005.europe-west1.run.app/campaigns';

  // ============================================================
  // A/B TEST ENDED — checkout_funnel_2026_q2 concluded.
  // Everyone now gets the classic (default) campaign experience.
  // The fresh path below is retained but permanently disabled via
  // the hardcoded `false`. To fully remove later, delete the fresh
  // functions and this detection block.
  // ============================================================
  const useFreshPromo = false; // A/B test ended — classic for everyone

  // Fresh-variant config (unused while test is off)
  const FRESH_RIBBON_TEXT = 'Summer Special';
  const FRESH_RESET_HOURS = 6;
  const FRESH_STORAGE_KEY = 'dmc_funnel_deadline'; // shared across Homepage → Pricing → Checkout

  // ============================================================
  // STYLES — ribbon-tag + countdown banner
  // ============================================================
  function insertStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .ribbon-tag {
        position: absolute;
        font-size: 14px;
        font-weight: 400;
        left: 50%;
        top: 0;
        transform: translate(-50%, -50%);
        padding: 8px 12px;
        width: 40%;
        min-width: 160px;
        text-align: center;
        background-color: #edff5d;
        border-radius: 30px;
        line-height: 1.2;
        color: black;
        display: inline-block;
        font-family: Montserrat;
      }

      #countdown-banner {
        display: none;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        width: 100%;
        padding: 6px 0px;
        background-color: #edff5d;
        color: #000;
        text-decoration: none;
        font-size: 1rem;
        font-family: "Montserrat", sans-serif;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        font-weight: 500;
      }

      #countdown-banner.dmc-pinned {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 9999;
      }

      .banner-content {
        display: flex;
        align-items: baseline;
      }

      #timer {
        margin-left: 5px;
      }

      #timer .unit {
        font-size: 0.75rem;
        font-weight: 400;
        margin-right: 10px;
        text-transform: uppercase;
      }

      .quantity {
        font-weight: 700;
        font-variant-numeric: tabular-nums;
      }

      @media (max-width: 768px) {
        .ribbon-tag {
          font-size: 11px;
          padding: 4px 10px;
        }
      }

      @media (max-width: 600px) {
        #countdown-banner {
          font-size: 0.9rem;
          gap: 5px;
          padding: 10px;
        }
        #timer .unit {
          margin-right: 5px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  // ============================================================
  // Helpers (default path)
  // ============================================================
  function resolveDeadline(month, day, now) {
    let d = new Date(now.getFullYear(), month, day, 23, 59, 59);
    if (d < now) d.setFullYear(d.getFullYear() + 1);
    return d;
  }

  function getActivePromo(campaigns) {
    const now = new Date();
    return (
      campaigns.find((p) => now <= resolveDeadline(p.month, p.day, now)) || null
    );
  }

  // ============================================================
  // DEFAULT PATH — dynamic ribbon + campaign countdown (from API)
  // This is now the experience for everyone.
  // ============================================================
  function injectRibbon(activePromo) {
    const title = activePromo ? activePromo.name : 'Best Value';
    const subtitle = activePromo ? activePromo.label : 'Limited Time Offer';

    function fill() {
      const el = document.getElementById('dmc-promo-ribbon');
      if (!el) return false;
      el.innerHTML = `${title}<br/><b>${subtitle}</b>`;
      el.style.display = 'inline-block';
      return true;
    }

    if (fill()) return;

    const observer = new MutationObserver(() => {
      if (fill()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function startCountdown(campaigns, bannerTarget) {
    let bannerEl = null;
    let intervalId = null;

    function createBannerElement() {
      const div = document.createElement('div');
      div.id = 'countdown-banner';
      div.innerHTML = `
        <span class="banner-content">
            <span style="margin-right: 10px;"></span>
            <span class="sale-text"></span>
        </span>
        <span class="banner-content" id="timer">
            <span id="days-container"><span id="b-days" class="quantity"></span><span class="unit">days</span></span>
            <span class="quantity" id="b-hours"></span><span class="unit">hrs</span>
            <span class="quantity" id="b-mins"></span><span class="unit">min</span>
            <span class="quantity" id="b-secs"></span><span class="unit">sec</span>
        </span>
      `;
      document.querySelector(bannerTarget).prepend(div);
      return div;
    }

    function update() {
      const now = new Date();
      const activePromo = getActivePromo(campaigns);

      if (!activePromo) {
        if (bannerEl) bannerEl.style.display = 'none';
        clearInterval(intervalId);
        return;
      }

      const deadline = resolveDeadline(activePromo.month, activePromo.day, now);
      const diff = deadline - now;
      const hoursLimit = 72 * 60 * 60 * 1000;

      if (diff > 0 && diff <= hoursLimit) {
        if (!bannerEl) bannerEl = createBannerElement();
        bannerEl.style.display = 'flex';
        bannerEl.querySelector('.sale-text').textContent = activePromo.name;

        const totalSecs = Math.floor(diff / 1000);
        const d = Math.floor(totalSecs / 86400);
        const h = Math.floor((totalSecs % 86400) / 3600);
        const m = Math.floor((totalSecs % 3600) / 60);
        const s = totalSecs % 60;

        const dContainer = document.getElementById('days-container');
        dContainer.style.display = d > 0 ? 'inline' : 'none';
        if (d > 0) document.getElementById('b-days').textContent = d;
        document.getElementById('b-hours').textContent = String(h).padStart(
          2,
          '0',
        );
        document.getElementById('b-mins').textContent = String(m).padStart(
          2,
          '0',
        );
        document.getElementById('b-secs').textContent = String(s).padStart(
          2,
          '0',
        );
      } else {
        if (bannerEl) bannerEl.style.display = 'none';
      }
    }

    intervalId = setInterval(update, 1000);
    update();
  }

  // ============================================================
  // FRESH PATH — retained but DISABLED (useFreshPromo is false).
  // Kept intact in case the test is revisited; remove for a full
  // cleanup.
  // ============================================================
  function injectRibbonFresh(text) {
    function fill() {
      const el = document.getElementById('dmc-promo-ribbon');
      if (!el) return false;
      el.innerHTML = text;
      el.style.display = 'inline-block';
      return true;
    }

    if (fill()) return;

    const observer = new MutationObserver(() => {
      if (fill()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function getNextResetFresh(now) {
    const midnight = new Date(now);
    midnight.setHours(0, 0, 0, 0);
    const blockMs = FRESH_RESET_HOURS * 60 * 60 * 1000;
    const elapsed = now - midnight;
    const blocks = Math.floor(elapsed / blockMs) + 1;
    return new Date(midnight.getTime() + blocks * blockMs);
  }

  function startCountdownFresh(bannerTarget, saleText) {
    let bannerEl = null;
    let spacerDone = false;

    function createBannerElement() {
      const div = document.createElement('div');
      div.id = 'countdown-banner';
      div.classList.add('dmc-pinned');
      div.innerHTML = `
        <span class="banner-content">
            <span style="margin-right: 10px;"></span>
            <span class="sale-text"></span>
        </span>
        <span class="banner-content" id="timer">
            <span id="days-container"><span id="b-days" class="quantity"></span><span class="unit">days</span></span>
            <span class="quantity" id="b-hours"></span><span class="unit">hrs</span>
            <span class="quantity" id="b-mins"></span><span class="unit">min</span>
            <span class="quantity" id="b-secs"></span><span class="unit">sec</span>
        </span>
      `;
      document.documentElement.appendChild(div);
      return div;
    }

    function update() {
      const now = new Date();
      const diff = deadline - now;

      if (!bannerEl) bannerEl = createBannerElement();
      bannerEl.style.display = 'flex';
      bannerEl.querySelector('.sale-text').textContent = saleText;

      if (!spacerDone) {
        spacerDone = true;
        document.body.style.paddingTop = bannerEl.offsetHeight + 'px';
      }

      const totalSecs = Math.max(0, Math.floor(diff / 1000));
      const h = Math.floor(totalSecs / 3600);
      const m = Math.floor((totalSecs % 3600) / 60);
      const s = totalSecs % 60;

      document.getElementById('days-container').style.display = 'none';
      document.getElementById('b-hours').textContent = String(h).padStart(
        2,
        '0',
      );
      document.getElementById('b-mins').textContent = String(m).padStart(
        2,
        '0',
      );
      document.getElementById('b-secs').textContent = String(s).padStart(
        2,
        '0',
      );
    }

    setInterval(update, 1000);
    update();
  }

  // ============================================================
  // initPromo — public entry point, called from the HTML
  // ============================================================
  window.initPromo = async function (bannerTarget) {
    insertStyles();
    bannerTarget = bannerTarget || 'body';

    // Test ended → useFreshPromo is false → always the default path.
    if (useFreshPromo) {
      injectRibbonFresh(FRESH_RIBBON_TEXT);
      startCountdownFresh(bannerTarget, FRESH_RIBBON_TEXT);
      return;
    }

    try {
      const res = await fetch(API_URL);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const campaigns = await res.json();

      const activePromo = getActivePromo(campaigns);
      injectRibbon(activePromo);
      startCountdown(campaigns, bannerTarget);
    } catch (err) {
      console.warn('initPromo: could not load campaigns.', err.message);
    }
  };
})();
